import { render, staticRenderFns } from "./InventoryReceiptTab.vue?vue&type=template&id=778e8d79&"
import script from "./InventoryReceiptTab.vue?vue&type=script&lang=js&"
export * from "./InventoryReceiptTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports